const t = {
  fontFamily: "Outfit",
  fontStyle: "normal",
  letterSpacing: "0",
  paragraphSpacing: "none",
  textCase: "none",
  textDecoration: "none",
  textTransform: "none"
}, e = {
  // Heading
  heading1: {
    ...t,
    fontSize: "38px",
    fontWeight: "Bold",
    lineHeight: "48px",
    weight: "700"
  },
  heading2: {
    ...t,
    fontSize: "30px",
    fontWeight: "Bold",
    lineHeight: "38px",
    weight: "700"
  },
  heading3: {
    ...t,
    fontSize: "26px",
    fontWeight: "Bold",
    lineHeight: "33px",
    weight: "700"
  },
  heading4: {
    ...t,
    fontSize: "22px",
    fontWeight: "Bold",
    lineHeight: "28px",
    weight: "700"
  },
  heading5: {
    ...t,
    fontSize: "20px",
    fontWeight: "Bold",
    lineHeight: "25px",
    weight: "700"
  },
  heading6: {
    ...t,
    fontSize: "18px",
    fontWeight: "Bold",
    lineHeight: "23px",
    weight: "700"
  },
  // Body L
  bodyLRegular: {
    ...t,
    fontSize: "16px",
    fontWeight: "Light",
    lineHeight: "20px",
    weight: "400"
  },
  bodyLItalic: {
    ...t,
    fontSize: "16px",
    fontWeight: "Light",
    lineHeight: "20px",
    weight: "400",
    fontStyle: "Italic"
  },
  bodyLMedium: {
    ...t,
    fontSize: "16px",
    fontWeight: "Medium",
    lineHeight: "20px",
    weight: "500"
  },
  bodyLSemibold: {
    ...t,
    fontSize: "16px",
    fontWeight: "SemiBold",
    lineHeight: "20px",
    weight: "600"
  },
  bodyLBold: {
    ...t,
    fontSize: "16px",
    fontWeight: "Bold",
    lineHeight: "20px",
    weight: "700"
  },
  // Body M
  bodyMRegular: {
    ...t,
    fontSize: "14px",
    fontWeight: "Light",
    lineHeight: "18px",
    weight: "400"
  },
  bodyMItalic: {
    ...t,
    fontSize: "14px",
    fontWeight: "Light",
    lineHeight: "18px",
    weight: "400",
    fontStyle: "Italic"
  },
  bodyMMedium: {
    ...t,
    fontSize: "14px",
    fontWeight: "Medium",
    lineHeight: "18px",
    weight: "500"
  },
  bodyMSemibold: {
    ...t,
    fontSize: "14px",
    fontWeight: "SemiBold",
    lineHeight: "18px",
    weight: "600"
  },
  bodyMBold: {
    ...t,
    fontSize: "14px",
    fontWeight: "Bold",
    lineHeight: "18px",
    weight: "700"
  },
  // Body S
  bodySRegular: {
    ...t,
    fontSize: "12px",
    fontWeight: "Light",
    lineHeight: "15px",
    weight: "400"
  },
  bodySItalic: {
    ...t,
    fontSize: "12px",
    fontWeight: "Light",
    lineHeight: "15px",
    weight: "400",
    fontStyle: "Italic"
  },
  bodySMedium: {
    ...t,
    fontSize: "12px",
    fontWeight: "Medium",
    lineHeight: "15px",
    weight: "500"
  },
  bodySSemibold: {
    ...t,
    fontSize: "12px",
    fontWeight: "SemiBold",
    lineHeight: "15px",
    weight: "600"
  },
  bodySBold: {
    ...t,
    fontSize: "12px",
    fontWeight: "Bold",
    lineHeight: "15px",
    weight: "700"
  },
  // Body XS
  bodyXSRegular: {
    ...t,
    fontSize: "10px",
    fontWeight: "Light",
    lineHeight: "13px",
    weight: "400"
  },
  bodyXSItalic: {
    ...t,
    fontSize: "10px",
    fontWeight: "Light",
    lineHeight: "13px",
    weight: "400",
    fontStyle: "Italic"
  },
  bodyXSMedium: {
    ...t,
    fontSize: "10px",
    fontWeight: "Medium",
    lineHeight: "13px",
    weight: "500"
  },
  bodyXSSemibold: {
    ...t,
    fontSize: "10px",
    fontWeight: "SemiBold",
    lineHeight: "13px",
    weight: "600"
  },
  bodyXSBold: {
    ...t,
    fontSize: "10px",
    fontWeight: "Bold",
    lineHeight: "13px",
    weight: "700"
  },
  // Table
  sort: {
    fontFamily: "Outfit",
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: "Bold",
    letterSpacing: "2px",
    lineHeight: "13px",
    paragraphSpacing: "0",
    textCase: "uppercase",
    textDecoration: "none",
    weight: "600"
  }
};
export {
  e as typography
};
